<template>
  <div class="modal fade" id="paySalesModal" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body p-4">
          <button
            type="button"
            id="pay-sale-close"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div class="text-center mb-6">
            <h4 class="mb-2 text-success">
              {{ $t("sales.pay_sale") }}
            </h4>
          </div>
          <hr class="mx-4 my-2" />

          <form
            id="upgradePlanForm"
            class="row g-4 mt-2"
            onsubmit="return false"
          >
            <div class="col-12">
              <label class="form-label" for="operationTime">{{
                $t("sales.id")
              }}</label>
              <input
                type="text"
                disabled
                v-model="selectedSale.id"
                class="form-control"
              />
            </div>
            <div class="col-12">
              <label class="form-label" for="price">{{
                $t("sales.price")
              }}</label>
              <div class="input-group">
                <input
                  type="number"
                  v-model="selectedSale.price"
                  disabled
                  class="form-control"
                />
                <div class="input-group-text">{{ settings.currency }}</div>
              </div>
            </div>
            <div class="col-12">
              <label class="form-label" for="paid">{{
                $t("sales.paid")
              }}</label>
              <div class="input-group">
                <input
                  type="number"
                  v-model="selectedSale.paid"
                  class="form-control"
                />
                <div class="input-group-text">{{ settings.currency }}</div>
              </div>
            </div>
            <div class="col-12 text-center mt-12">
              <button
                class="btn btn-success me-2"
                type="button"
                @click="paySale(selectedSale)"
              >
                <i class="ti ti-circle-plus me-1"></i>
                {{ $t("sales.pay") }}
              </button>
              <button
                type="reset"
                class="btn btn-label-secondary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {{ $t("control.cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "SalesPay",
  computed: {
    ...mapGetters(["settings"]),
  },
  props: {
    selectedSale: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async paySale(sale) {
      const message = this.$t("sales.sale_paid");
      document.getElementById("pay-sale-close").click();
      try {
        const response = await axios.post(`sales/${sale.id}/pay`, {
          amount: sale.paid,
        });
        if (response.status == 200) {
          this.$notify({
            text: message,
            type: "success",
          });
        }
      } catch (error) {
        this.$notify({
          text:
            error.response?.data?.message ||
            this.$t("control.some_thing_went_wrong_please_try_again"),
          type: "error",
        });
      }
      this.$emit("updated");
    },
  },
};
</script>
